import { useEffect, useState } from "react";

export default function useScript({
    url,
    atributos,
    habilitado
}:{
    url:string, 
    atributos?:{nome: string, valor: any}[],
    habilitado?:boolean;
}) {
    habilitado = habilitado ?? true;
    const scriptEl = document.createElement("script");
    const headEl = document.querySelector("head");
    const [ isSucesso, setIsSucesso ] = useState(false);
    const [ isErro, setIsErro ] = useState(false);
    const [ isCarregando, setCarregando ] = useState(false);

    useEffect(() => {
        if (habilitado) {            
            new Promise((resolve, reject) => {
                scriptEl.setAttribute("src", url);
        
                atributos?.forEach(({nome, valor}) => {
                    scriptEl.setAttribute(nome, valor);
                });
    
                scriptEl.onload = resolve;
                scriptEl.onerror = reject;
                
                headEl!.appendChild(scriptEl);
            }).then((...data) => {
                setIsSucesso(true);
                setIsErro(false);
                return data;
            }).catch(() => {
                setIsErro(true);
                setIsSucesso(false);
            }).finally(() => {
                setCarregando(false);
            });
            
            return () => { headEl!.removeChild(scriptEl); }
        }
    }, [habilitado, scriptEl, url]);

    return {
        elemento : scriptEl,
        isSucesso,
        isErro,
        isCarregando,
        removeNode : () => { headEl!.removeChild(scriptEl); }
    };
}